import { Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface InlineWarningProps {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * InlineWarning — amber left-border warning banner.
 * Non-blocking, small, used inline within forms.
 * Per design spec: amber left border, #FFFBEB background.
 */
export default function InlineWarning({ message, action }: InlineWarningProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        px: 2,
        py: 1.25,
        borderLeft: "3px solid",
        borderColor: "warning.main",
        backgroundColor: "#FFFBEB",
        borderRadius: "0 8px 8px 0",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberIcon sx={{ fontSize: 18, color: "warning.main", flexShrink: 0 }} />
        <Typography variant="body2" color="text.primary" sx={{ fontWeight: 500 }}>
          {message}
        </Typography>
      </Box>
      {action && (
        <Button
          size="small"
          variant="outlined"
          onClick={action.onClick}
          sx={{
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            borderColor: "warning.main",
            color: "warning.dark",
            flexShrink: 0,
            "&:hover": { borderColor: "warning.dark", bgcolor: "#FEF3C7" },
          }}
        >
          {action.label}
        </Button>
      )}
    </Box>
  );
}
